import cx from "classnames";
import { FC, ReactNode } from "react";

export enum OutlineBadgeColor {
  Blue = "Blue",
  Charcoal = "Charcoal",
  Gray = "Gray",
  Green = "Green",
  Magenta = "Magenta",
  Navy = "Navy",
  Orange = "Orange",
  Plain = "Plain",
  Purple = "Purple",
  Red = "Red",
  Slate = "Slate",
  Yellow = "Yellow",
}

interface OutlineBadgePalette {
  background: string;
  border: string;
  text: string;
}

const OUTLINE_BADGE_COLOR_MAP: Record<OutlineBadgeColor, OutlineBadgePalette> = {
  [OutlineBadgeColor.Blue]: { background: "#F0F6FF", border: "#005CBF", text: "#005CBF" }, // $blue50 / $blue600
  [OutlineBadgeColor.Charcoal]: { background: "#DFDFF0", border: "#32323C", text: "#32323C" }, // was -terminated
  [OutlineBadgeColor.Gray]: { background: "#E5E5E5", border: "#404142", text: "#404142" },
  [OutlineBadgeColor.Green]: { background: "#F6FCF9", border: "#286E4D", text: "#286E4D" }, // $green50 / $green800
  [OutlineBadgeColor.Magenta]: { background: "#FFCCFF", border: "#FF00FF", text: "#32323C" }, // was -targeted
  [OutlineBadgeColor.Navy]: { background: "#ADE8F4", border: "#03045E", text: "#03045E" }, // was -excluded
  [OutlineBadgeColor.Orange]: { background: "#FFE9D9", border: "#CF5A00", text: "#32323C" }, // was -prospect
  [OutlineBadgeColor.Plain]: { background: "transparent", border: "currentColor", text: "inherit" },
  [OutlineBadgeColor.Purple]: { background: "#C9BDEA", border: "#402294", text: "#402294" }, // was -market
  [OutlineBadgeColor.Red]: { background: "#FCF5F5", border: "#992929", text: "#992929" },
  [OutlineBadgeColor.Slate]: { background: "#DFDFF0", border: "#504D5C", text: "#504D5C" }, // was -net-new
  [OutlineBadgeColor.Yellow]: { background: "#FFF5EC", border: "#8D3C00", text: "#8D3C00" }, // $amber50
};

interface OutlineBadgeProps {
  children: ReactNode;
  className?: string;
  color: OutlineBadgeColor;
  testId?: string;
}

export const OutlineBadge: FC<OutlineBadgeProps> = ({ children, className, color, testId }) => {
  const { background, border, text } = OUTLINE_BADGE_COLOR_MAP[color];

  return (
    <span
      className={cx("qes-outline-badge", className)}
      data-testid={testId}
      style={{ backgroundColor: background, borderColor: border, color: text }}
    >
      {children}
    </span>
  );
};
